module.exports = __webpack_public_path__ + "static/media/adda52.674a9ea1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/adda52.gif
// module id = 338
// module chunks = 0